module.exports = __webpack_public_path__ + "img/gungsiimage.94532c34.png";